<template>
  <v-card class="d-flex align-items-center text-center mt-4" style="min-height: 350px;">
    <div class="w-100">

      <v-card-title class="card-title">
        Datos Personales
      </v-card-title>
      <v-card-text>
        <v-row class="pa-3">
          <v-col cols="12" md="4">
            <BaseInput label="Nro Legajo*" name="nro_legajo" v-model="legajo.nro_legajo" :rules="'required'"
              :validationErrors="errors" :loading="loading_nro_legajo" :disabled="legajo.id>0"/>

            <BaseCombobox label="Género" name="gender" v-model="legajo.gender" :items="genders" item-text="name"
              item-value="id" :loading="loading_genders" :rules="''" :validationErrors="errors" />



            <BaseDatePicker label="Fecha de nacimiento" name="birthdate" v-model="legajo.birthdate" :rules="''"
              :validationErrors="errors" />

            <BaseCombobox label="Nivel de estudio" name="level_study" v-model="legajo.level_study"
              :items="level_studies" item-text="name" item-value="id" :loading="loading_level_studies" :rules="''"
              :validationErrors="errors" />

          </v-col>
          <v-col cols="12" md="4">
            <BaseInput label="Nombre*" name="name" v-model="legajo.name" :rules="'required'"
              :validationErrors="errors" />

            <BaseCombobox label="Tipo documento*" name="document_type" v-model="legajo.document_type" :items="doc_types"
              item-text="name" item-value="id" :loading="loading_doc_types" :rules="'required'"
              :validationErrors="errors" />

            <BaseInput label="Nacionalidad" name="nationality" v-model="legajo.nationality" :rules="'required'"
              :validationErrors="errors" />

            <BaseInput label="Discapacidad" name="disability" v-model="legajo.disability" :rules="'required'"
              :validationErrors="errors" />
          </v-col>
          <v-col cols="12" md="4">

            <BaseInput label="Apellido*" name="surname" v-model="legajo.surname" :rules="'required'"
              :validationErrors="errors" />
            <BaseInput label="Documento*" name="document" v-model="legajo.document" :rules="'required'"
              :validationErrors="errors" />

            <BaseInput label="CUIL" name="cuil" v-model="legajo.cuil" :rules="''"
              :validationErrors="errors" />


            <BaseCombobox label="Estado Civil" name="civil_status" v-model="legajo.civil_status" :items="civils_status"
              item-text="name" item-value="id" :loading="loading_civils_status" :rules="''"
              :validationErrors="errors" />

          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>

import { listService } from '../../../libs/ws/listService';
import BaseInput from "@/components/BaseInput.vue";
import BaseCombobox from "@/components/BaseCombobox.vue";
import BaseDatePicker from "@/components/BaseDatePicker.vue";

export default {
  components: { BaseInput, BaseCombobox, BaseDatePicker },
  name: "CardInfo",
  props: {
    legajo: {
      type: Object
    },
    service: {
      type: Object
    },
  },
  data() {
    return {

      menu_birthdate: false,
      doc_types: [],
      genders: [],
      civils_status: [],
      level_studies: [],
      loading_genders: false,
      loading_doc_types: false,
      loading_civils_status: false,
      loading_level_studies: false,
      loading_nro_legajo: false,
    };
  },
  mounted() {
    this.loadGenders();
    this.loadDocTypes();
    this.loadLevelStudies();
    this.loadCivilsStatus();
    if(this.legajo.id == 0) {
      this.getNextNroLegajo();
    }
  },
  created() {

  },
  methods: {
    getNextNroLegajo() {
      this.loading_nro_legajo = true;
      this.service.get_next_nro_legajo()
        .then((response) => {
          if (response.status) {
            this.legajo.nro_legajo = response.result.last;
          }
        })
        .catch((e) => {
          console.log("Error al obtener el próximo número de legajo");
          console.log(e);
        })
        .finally(() => {
          this.loading_nro_legajo = false;
        });
    },
    async validate() {
      const valid = await this.$validator.validateAll();
      return valid;
    },
    loadGenders() {
      this.loading_genders = true;

      listService
        .list_genders()
        .then((response) => {
          if (response.status)
            this.genders = response.result;
        })
        .catch((e) => {
          console.log("categories.filter error");
          console.log(e);
        })
        .finally(() => {
          this.loading_genders = false;
        });
    },
    loadDocTypes() {
      this.loading_doc_types = true;

      listService
        .list_doc_types()
        .then((response) => {
          if (response.status)
            this.doc_types = response.result;

        })
        .catch((e) => {
          console.log("categories.filter error");
          console.log(e);
        })
        .finally(() => {
          this.loading_doc_types = false;
        });

    },
    loadLevelStudies() {
      this.loading_level_studies = true;

      listService
        .list_level_studies()
        .then((response) => {
          if (response.status)
            this.level_studies = response.result;

        })
        .catch((e) => {
          console.log("categories.filter error");
          console.log(e);
        })
        .finally(() => {
          this.loading_level_studies = false;
        });
    },
    loadCivilsStatus() {
      this.loading_civils_status = true;

      listService
        .list_civil_status()
        .then((response) => {
          if (response.status)
            this.civils_status = response.result;

        })
        .catch((e) => {
          console.log("categories.filter error");
          console.log(e);
        })
        .finally(() => {
          this.loading_civils_status = false;
        });



    },
  },
};
</script>
